"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SignUpCongrats = function () {
    var _a, _b, _c, _d;
    var t = (0, next_intl_1.useTranslations)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var bonusData = (0, swr_hooks_1.useCalculateWelcomePackage)();
    var config = (0, swr_hooks_1.useConfig)();
    var brand = (0, swr_hooks_1.useBrand)().brand;
    var useAmountForBonus = !!(config === null || config === void 0 ? void 0 : config.signUpCongratsUseAmount);
    var currencySymbol = (0, apps_shared_1.getCurrencySymbol)(bonusData === null || bonusData === void 0 ? void 0 : bonusData.currency);
    var formatBonusAmount = function (amount) {
        return amount ? "".concat(amount).concat(currencySymbol) : '';
    };
    var formatBonusPercent = function (percent) { return percent || ''; };
    var currentBonusValue = useAmountForBonus
        ? formatBonusAmount((_a = bonusData.currentBonus) === null || _a === void 0 ? void 0 : _a.amount) ||
            formatBonusPercent((_b = bonusData.currentBonus) === null || _b === void 0 ? void 0 : _b.percent)
        : formatBonusPercent((_c = bonusData.currentBonus) === null || _c === void 0 ? void 0 : _c.percent);
    var totalBonusValue = useAmountForBonus
        ? formatBonusAmount(bonusData.amount) ||
            formatBonusPercent(bonusData.percent)
        : formatBonusPercent(bonusData.percent);
    var bonus = config.signUpCongratsBonusCurrent
        ? bonusData.currentBonus.fs
            ? t('promotions.welcomeBonusMobile', {
                bonus: currentBonusValue,
                freespins: (_d = bonusData.currentBonus) === null || _d === void 0 ? void 0 : _d.fs,
            })
            : currentBonusValue
        : bonusData.freeSpins
            ? t('promotions.welcomeBonusMobile', {
                bonus: totalBonusValue,
                freespins: bonusData.freeSpins,
            })
            : totalBonusValue;
    return (react_1.default.createElement(ui_components_1.Modal, { width: "335px", height: "auto", padding: "16px", className: styles_module_scss_1.default.modalSignUpCongrats, saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.logo },
                react_1.default.createElement("img", { src: "/img/logo.svg", alt: "logo" })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.welcome }, t('translation.signUpCongratsWelcome')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text1 }, t('translation.signUpCongratsText1', { brand: brand })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text2 }, t('translation.signUpCongratsText2')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.welcomePackage },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.welcomePackageTitle }, t('promotions.welcomePackageBonusTitle')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.welcomePackageBonus }, bonus)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text3 }, t('translation.signUpCongratsText3')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { onClick: openDeposit, maxWidth: "100%", width: "100%" }, t('translation.deposit'))))));
};
exports.default = SignUpCongrats;
